import { ChangeDetectionStrategy, Component } from '@angular/core'
import { NavbarComponent } from '../navbar/navbar.component'
import { RouterOutlet } from '@angular/router'

@Component({
	selector: 'app-layout',
	template: `
		<app-navbar></app-navbar>
		<main class="p-3">
			<router-outlet></router-outlet>
		</main>
	`,
	styleUrls: ['./layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NavbarComponent, RouterOutlet],
})
export class LayoutComponent {}
